import { FC } from "react";
import { localeStringOptions } from "../../common/constants/common.constants";
import "./TokenInfo.scss";

const TokenInfo: FC<{
  name: string;
  balance: number;
  image: string;
  symbol: string;
  isFundraisingConfig?: boolean;
}> = ({ balance, image, name, symbol, isFundraisingConfig }) => {
  return (
    <div className="token-info">
      <div className="token-info__name-and-img">
        <img src={image} />
        <p className="token-info__name">{name}</p>
      </div>
      <div className="token-info__balance-info">
        {!isFundraisingConfig && (
          <p className="token-info__balance">
            {balance.toLocaleString(undefined, localeStringOptions)}
          </p>
        )}
        <p className="token-info__symbol">{symbol}</p>
      </div>
    </div>
  );
};

export default TokenInfo;
